export enum TicketScheduledPeriodOptions {
  Today = 'today',
  Next7Days = 'next-7-days',
  Next30Days = 'next-30-days',
  Overdue = 'overdue',
}
